module.exports = __webpack_public_path__ + "img/daphne.1490c72b.png";